module.exports = __webpack_public_path__ + "static/media/img_expired.28c24c27.png";